import React from "react";
import classes from "./CouponCard.module.css";
import { Pencil, Trash } from "../../constant";
import Popover from "../Popovers";

const CouponCard = ({ coupon, onEdit, onDelete, setShow, onView, data }) => {
  // Menu items for the coupon actions
  const menuItems = [
    {
      label: "Edit Coupon",
      icon: <Pencil className={classes.icon} />,
      command: () => {
        if (typeof onEdit === "function") {
          onEdit(coupon);

        }
      },
    },
    {
      label: "Delete Coupon",
      icon: <Trash className={classes.icon} />,
      command: () => {
        if (typeof onDelete === "function") {
          onDelete(coupon);
        }
      },
    },
  ];

  console.log(coupon);

  return (
    <address className={classes.wrapper}>
      <header className={classes.header}>
        <h2 className={classes.country}>{coupon?.couponCode}</h2>
        <span className={classes.actionMenu}>
          <Popover items={menuItems} />
        </span>
      </header>
      <div className={classes.detailsWrapper}>
        <h3 className={[classes.activeInActive, coupon.active ? classes.active : classes.inActive].join(" ")}>{coupon?.active ? "Active" : "InActive"}</h3>
        {coupon?.couponEndDate && <h3 className={classes.endDate}>End Date: <span>{coupon?.couponEndDate}</span></h3>}
        {
          coupon?.couponDiscountPercentage !== null ?
            <h3 className={classes.discountPercentage}><span>Rs. </span>{coupon?.couponDiscountPercentage}% OFF</h3>
            :
            <h3 className={classes.discountAmount}><span>Rs. </span>{coupon?.couponDiscountAmount} OFF</h3>
        }

      </div>
    </address>
  );
};

// Add default props
CouponCard.defaultProps = {
  coupon: {},
  onEdit: () => { },
  onDelete: () => { },
  onView: () => { },
};

export default CouponCard;
